// src/components/loading/ContentSkeleton.tsx
import { Spinner } from 'react-bootstrap';
import logo from '@/assets/of-logo-small.png';

interface ContentSkeletonProps {
    show?: boolean;
}

const ContentSkeleton = ({ show = true }: ContentSkeletonProps) => {
    if (!show) return null;

    return (
        <div
            className="h-100 d-flex"
            style={{
                marginTop: '25vh',
                width: '100%',
                justifyContent: 'center',
                paddingRight: '15%' // This helps offset the sidenav space
            }}
        >
            <div className="position-relative" style={{ width: '3.5rem', height: '3.5rem' }}>
                <Spinner
                    animation="border"
                    role="status"
                    style={{
                        color: 'rgba(170, 62, 17, 0.3)',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        borderWidth: '2px'
                    }}
                />
                <img
                    src={logo}
                    alt="Logo"
                    style={{
                        width: '2rem',
                        height: '2rem',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        opacity: 0.5
                    }}
                />
            </div>
            <span className="visually-hidden">Loading...</span>
        </div>
    );
};

export default ContentSkeleton;